export default "__VITE_ASSET__18liA8Ja__"